// ---------------------------------------------------------------------------
// PWA Caisse Tablette — Employee top bar
// Shows user name, POS name, online status, logout button
// ---------------------------------------------------------------------------

import { useAuthStore } from '@/store/auth-store';
import { useConfigStore } from '@/store/config-store';
import { useAppStore } from '@/store/app-store';
import { authService } from '@/services/auth-service';

export default function EmployeeBar() {
  const user = useAuthStore((s) => s.user);
  const posName = useConfigStore((s) => s.posName);
  const posId = useConfigStore((s) => s.posId);
  const isOnline = useAppStore((s) => s.isOnline);

  function handleLogout() {
    authService.logout();
  }

  const displayName = user
    ? `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim() || user.email
    : 'Utilisateur';

  return (
    <header className="sticky top-0 z-50 flex items-center justify-between px-4 py-2 bg-surface-light border-b border-white/10">
      {/* Left: user info */}
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-accent-light shrink-0">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
        <span className="text-sm font-medium text-white truncate">
          {displayName}
        </span>
      </div>

      {/* Center: POS name */}
      <span className="text-xs text-gray-400 px-2 truncate">
        {posName || `POS #${posId}`}
      </span>

      {/* Right: status + logout */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1.5">
          <div className={`w-2.5 h-2.5 rounded-full ${isOnline ? 'bg-success' : 'bg-danger'}`} />
          <span className="text-xs text-gray-400 hidden sm:inline">
            {isOnline ? 'En ligne' : 'Hors ligne'}
          </span>
        </div>
        <button
          type="button"
          onClick={handleLogout}
          className="p-1.5 rounded-full text-gray-400 hover:text-danger hover:bg-white/5"
          aria-label="Deconnexion"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </button>
      </div>
    </header>
  );
}
